module.exports = __webpack_public_path__ + "img/image 15.9be707d3.png";